// extracted by mini-css-extract-plugin
export default {"desktop":"Desktop_desktop__l0wWF","desktopContainer":"Desktop_desktopContainer__s2Dkm","desktopItem":"Desktop_desktopItem__FJbbA","sponsors":"Desktop_sponsors__2d+E3"};